import { render } from "./SmileIcon.vue?vue&type=template&id=06ad9fca"
import script from "./SmileIcon.vue?vue&type=script&lang=ts"
export * from "./SmileIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script